import React from 'react';

import PlayerSpeedControls from '../../containers/PlayerSpeedControls';
import PlayerOptions from '../../containers/PlayerOptions';
import DistanceText from '../distanceText/DistanceText';
import SpeedText from '../speedText/SpeedText';
import SharingControl from '../sharingControl/SharingControl';
import Fullscreen from '../../containers/PlayerFullscreen';
import TerrainProfile from '../terrainProfile/TerrainProfileCanvas';
import TimeSlider from '../../containers/TimeSlider';
import TrackSelectorButton from '../../containers/TrackSelectorButton';

import style from './playerControls.css';

const kMobileControlsTimeout = 3000;

const TerrainProfileHolder = ({ hideElements }) => {
  if (hideElements.includes('terrainProfile')) return null;
  return <TerrainProfile />;
};

class MobileControls extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timeout: undefined,
    };
  }

  resetHideTimer() {
    // Hide the controls after X seconds of nothing being clicked
    clearTimeout(this.state.timeout);
    this.state.timeout = setTimeout(() => {
      if (this.props.showControls) this.props.toggleControls();
    }, kMobileControlsTimeout);
  }

  render() {
    const { isMobile, showControls, hideElements } = this.props;
    if (!isMobile) return null;

    if (showControls) this.resetHideTimer();

    return (
      <div
        className={`${style.mobileControls} ${showControls ? '' : style.hidden}`}
        onClick={() => this.resetHideTimer()}
      >
        <PlayerOptions />
        <PlayerSpeedControls />
        {hideElements.includes('sharing') ? (
          <div className={style.filler} />
        ) : (
          <SharingControl parent='footer' isMobile={isMobile} />
        )}
      </div>
    );
  }
}

const ControlBarMobile = () => (
  <div className={`${style.controlBar} controlBar padIphoneX`}>
    <SpeedText />
    <DistanceText />
  </div>
);

const ControlBarDesktop = ({ rootElement, miniUi, hideElements }) => (
  <div className={`${style.controlBar} controlBar ${hideElements.includes('terrainProfile') ? style.dark : ''}`}>
    <div className={style.buttonHolderLeft}>
      <PlayerSpeedControls />
      <span className={style.spacer} />
      <SpeedText />
    </div>
    {miniUi && <TimeSlider />}
    <div className={style.buttonHolderRight}>
      <DistanceText />
      <span className={style.spacerHalf} />
      {miniUi && <TrackSelectorButton />}
      <PlayerOptions />
      {hideElements.includes('sharing') ? null : <SharingControl parent='footer' isMobile={false} />}
      <Fullscreen rootElement={rootElement} />
    </div>
  </div>
);

const ControlBar = ({ rootElement, isMobile, miniUi, hideElements }) => {
  if (hideElements.includes('controlBar')) {
    return null;
  } else {
    return isMobile ? (
      <ControlBarMobile />
    ) : (
      <ControlBarDesktop miniUi={miniUi} hideElements={hideElements} rootElement={rootElement} />
    );
  }
};

const PlayerControls = props => {
  // Hide the TerrainProfile while MiniUI mode is active
  const hideElements = props.miniUi ? props.hideElements.concat(['terrainProfile']) : props.hideElements;

  return (
    <div className={style.playerControls}>
      <MobileControls
        isMobile={props.isMobile}
        showControls={props.showControls}
        hideElements={hideElements}
        toggleControls={props.toggleControls}
      />
      <div className={`${style.slideIn} ${props.isMobile ? 'isMobile' : 'isDesktop'}`}>
        <TerrainProfileHolder hideElements={hideElements} />
        <ControlBar
          hideElements={hideElements}
          isMobile={props.isMobile}
          miniUi={props.miniUi}
          rootElement={props.rootElement}
        />
      </div>
    </div>
  );
};

export default PlayerControls;
